/* CaliHeat · JS (sin dependencias) */
(function () {
  'use strict';

  var d = document;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- Aparición progresiva ---------- */
  var revealObserver = null;
  function initReveal(scope) {
    var els = [].slice.call((scope || d).querySelectorAll('.ch-reveal:not(.is-in)'));
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            revealObserver.unobserve(e.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -5% 0px' });
    }
    els.forEach(function (el) { revealObserver.observe(el); });
  }

  /* ---------- Carrito (contador de la cabecera) ---------- */
  function refreshCartCount() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        [].forEach.call(d.querySelectorAll('[data-cart-count]'), function (el) {
          el.textContent = cart.item_count;
          el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump');
          if (cart.item_count > 0) el.removeAttribute('data-zero');
          else el.setAttribute('data-zero', '');
        });
      })
      .catch(function () {});
  }

  /* ---------- Producto ---------- */
  function initProduct(section) {
    var form = section.querySelector('[data-ch-form]');
    var variantsEl = section.querySelector('script[data-variants]');
    if (!form || !variantsEl || section.__chInit) return;
    section.__chInit = true;

    var variants = [];
    try { variants = JSON.parse(variantsEl.textContent); } catch (e) { return; }

    var idInput = form.querySelector('[data-variant-id]');
    var qty = form.querySelector('[data-qty]');
    var msg = form.querySelector('[data-msg]');
    var behavior = form.getAttribute('data-behavior') || 'cart';
    var cartUrl = form.getAttribute('data-cart-url') || (root + 'cart');
    var buttons = [].slice.call(section.querySelectorAll('[data-buy]'));
    var priceEls = [].slice.call(section.querySelectorAll('[data-price]'));
    var compareEl = section.querySelector('[data-compare]');
    var currency = section.getAttribute('data-currency') || 'EUR';
    var locale = section.getAttribute('data-locale') || 'es';
    var busy = false;
    var currentVariant = null;

    function money(cents) {
      try {
        return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2) + ' ' + currency;
      }
    }

    function setMsg(text, isError) {
      if (!msg) return;
      msg.textContent = text || '';
      msg.style.color = isError ? '#B3261E' : '';
    }

    function setButtons(disabled, label) {
      buttons.forEach(function (b) {
        b.disabled = disabled;
        if (label) b.textContent = label;
      });
    }

    function selectedOptions() {
      var out = [];
      [].forEach.call(form.querySelectorAll('fieldset[data-option-index]'), function (fs) {
        var c = fs.querySelector('input:checked');
        out.push(c ? c.value : null);
      });
      return out;
    }

    function findVariant(opts) {
      if (!opts.length) return variants[0] || null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var j = 0; j < opts.length; j++) {
          if (v.options[j] !== opts[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function showMedia(id) {
      var slides = section.querySelectorAll('[data-slide]');
      if (!slides.length || !id) return;
      var found = false;
      [].forEach.call(slides, function (s) {
        var on = s.getAttribute('data-slide') === String(id);
        if (on) found = true;
        s.classList.toggle('is-active', on);
      });
      if (!found) return;
      [].forEach.call(section.querySelectorAll('[data-thumb]'), function (t) {
        t.setAttribute('aria-pressed', t.getAttribute('data-thumb') === String(id) ? 'true' : 'false');
      });
    }

    function applyVariant() {
      var v = findVariant(selectedOptions());
      currentVariant = v;
      if (!v) {
        idInput.value = '';
        setButtons(true, 'NO DISPONIBLE');
        setMsg('Esa combinación no está disponible. Elige otra opción.', true);
        return;
      }
      idInput.value = v.id;
      var newPrice = money(v.price);
      priceEls.forEach(function (el) {
        if (section.__chPriceSet && el.textContent !== newPrice) {
          el.classList.remove('is-pop'); void el.offsetWidth; el.classList.add('is-pop');
        }
        el.textContent = newPrice;
      });
      section.__chPriceSet = true;
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = money(v.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      setButtons(!v.available, v.available ? 'COMPRAR AHORA' : 'AGOTADO');
      setMsg('', false);
      if (v.featured_media && v.featured_media.id) showMedia(v.featured_media.id);
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
    }

    form.addEventListener('change', function (e) {
      if (e.target && e.target.type === 'radio') applyVariant();
    });

    /* Cantidad */
    function getQty() {
      var n = parseInt(qty.value, 10);
      return isNaN(n) || n < 1 ? 1 : n;
    }
    var minus = form.querySelector('[data-qty-minus]');
    var plus = form.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () { qty.value = Math.max(1, getQty() - 1); });
    if (plus) plus.addEventListener('click', function () { qty.value = getQty() + 1; });
    qty.addEventListener('change', function () { qty.value = getQty(); });

    /* Galería */
    [].forEach.call(section.querySelectorAll('[data-thumb]'), function (t) {
      t.addEventListener('click', function () { showMedia(t.getAttribute('data-thumb')); });
    });
    if (!section.querySelector('[data-slide].is-active')) {
      var first = section.querySelector('[data-slide]');
      if (first) showMedia(first.getAttribute('data-slide'));
    }

    /* Añadir al carrito (acción real de Shopify) */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy) return;
      if (!idInput.value || !currentVariant && selectedOptions().length) {
        setMsg('Elige una opción disponible antes de comprar.', true);
        var firstInput = form.querySelector('fieldset[data-option-index] input');
        if (firstInput) firstInput.focus();
        return;
      }
      busy = true;
      buttons.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
      var prevLabel = buttons.length ? buttons[0].textContent : '';
      setButtons(true, 'AÑADIENDO…');
      setMsg('', false);

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: getQty() }] })
      })
        .then(function (r) {
          return r.json().then(function (j) {
            if (!r.ok) throw new Error(j.description || j.message || 'error');
            return j;
          });
        })
        .then(function () {
          if (behavior === 'checkout') {
            window.location.href = root + 'checkout';
            return null;
          }
          return refreshCartCount().then(function () {
            if (window.chCelebrate) window.chCelebrate();
            if (!msg) return;
            msg.textContent = 'Añadido al carrito. ';
            msg.style.color = '';
            var a = d.createElement('a');
            a.href = cartUrl;
            a.textContent = 'Ver carrito';
            msg.appendChild(a);
            msg.appendChild(d.createTextNode(' · '));
            var b = d.createElement('a');
            b.href = root + 'checkout';
            b.textContent = 'Finalizar compra';
            msg.appendChild(b);
          });
        })
        .catch(function (err) {
          setMsg(err && err.message && err.message !== 'error' ? err.message : 'No se ha podido añadir al carrito. Inténtalo de nuevo.', true);
        })
        .then(function () {
          busy = false;
          buttons.forEach(function (b) { b.removeAttribute('aria-busy'); });
          if (behavior !== 'checkout' || msg && msg.textContent) {
            var v = currentVariant;
            setButtons(v ? !v.available : false, v && !v.available ? 'AGOTADO' : (prevLabel === 'AÑADIENDO…' ? 'COMPRAR AHORA' : prevLabel));
          }
        });
    });

    applyVariant();

    /* Barra de compra persistente */
    var sticky = section.querySelector('[data-sticky]');
    var mainBtn = section.querySelector('#ch-buy');
    if (sticky && mainBtn) {
      var shown = false;
      var body = d.body;

      var setBarHeight = function () {
        var h = shown ? sticky.offsetHeight + (window.innerWidth >= 768 ? 20 : 0) : 0;
        body.style.setProperty('--ch-bar-h', h + 'px');
      };
      var toggle = function (show) {
        if (show === shown) return;
        shown = show;
        sticky.classList.toggle('is-on', show);
        body.classList.toggle('ch-sticky-on', show);
        setBarHeight();
      };

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var e = entries[entries.length - 1];
          toggle(!e.isIntersecting);
        }, { threshold: 0 }).observe(mainBtn);
      } else {
        var ticking = false;
        var check = function () {
          var r = mainBtn.getBoundingClientRect();
          toggle(r.bottom < 0 || r.top > window.innerHeight);
          ticking = false;
        };
        window.addEventListener('scroll', function () {
          if (!ticking) { ticking = true; window.requestAnimationFrame(check); }
        }, { passive: true });
        check();
      }
      window.addEventListener('resize', setBarHeight);
    }
  }

  function initAll(scope) {
    initReveal(scope);
    [].forEach.call((scope || d).querySelectorAll('[data-ch-product]'), initProduct);
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  /* Editor de temas de Shopify */
  d.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

/* Aviso de WhatsApp */
(function () {
  'use strict';
  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }
  ready(function () {
    var wrap = document.querySelector('[data-wa-wrap]');
    var bubble = wrap && wrap.querySelector('[data-wa-bubble]');
    if (!bubble) return;
    var key = 'ch_wa_closed';
    var closed = false;
    try { closed = window.sessionStorage.getItem(key) === '1'; } catch (e) {}
    var hideTimer;
    function hide(store) {
      bubble.hidden = true;
      window.clearTimeout(hideTimer);
      if (store) { try { window.sessionStorage.setItem(key, '1'); } catch (e) {} }
    }
    var closeBtn = wrap.querySelector('[data-wa-close]');
    if (closeBtn) closeBtn.addEventListener('click', function () { hide(true); });
    if (closed) return;
    window.setTimeout(function () {
      bubble.hidden = false;
      hideTimer = window.setTimeout(function () { hide(false); }, 10000);
    }, 3000);
  });
})();

/* Efectos de movimiento y de compra */
(function () {
  'use strict';
  var d = document;
  var mq = function (q) { return !!(window.matchMedia && window.matchMedia(q).matches); };
  var reduce = mq('(prefers-reduced-motion: reduce)');
  var hover = mq('(hover: hover) and (pointer: fine)');

  function start() {
    /* Barra de progreso de lectura, cabecera y parallax suave */
    var bar = d.createElement('div');
    bar.className = 'ch-progress';
    bar.setAttribute('aria-hidden', 'true');
    d.body.appendChild(bar);
    var header = d.querySelector('.ch-header');
    var heroImg = d.querySelector('.ch-hero__media img');
    var ticking = false;
    function onScroll() {
      var st = window.pageYOffset || d.documentElement.scrollTop || 0;
      var max = d.documentElement.scrollHeight - window.innerHeight;
      bar.style.setProperty('--p', max > 0 ? Math.min(1, st / max) : 0);
      if (header) header.classList.toggle('is-scrolled', st > 20);
      if (heroImg && !reduce && st < window.innerHeight * 1.2) {
        heroImg.style.setProperty('--ch-py', Math.min(16, st * 0.05) + 'px');
      }
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(onScroll); }
    }, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();

    /* Inclinación 3D y foco de luz en tarjetas (solo con ratón) */
    if (hover && !reduce) {
      var SEL = '.ch-card,.ch-review,.ch-feat__img';
      d.addEventListener('pointermove', function (e) {
        var t = e.target.closest && e.target.closest(SEL);
        if (!t) return;
        var r = t.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width;
        var y = (e.clientY - r.top) / r.height;
        t.style.setProperty('--mx', (x * 100) + '%');
        t.style.setProperty('--my', (y * 100) + '%');
        t.style.setProperty('--rx', ((0.5 - y) * 6) + 'deg');
        t.style.setProperty('--ry', ((x - 0.5) * 8) + 'deg');
        t.classList.add('is-tilt');
      }, { passive: true });
      d.addEventListener('pointerout', function (e) {
        var t = e.target.closest && e.target.closest(SEL);
        if (t && !t.contains(e.relatedTarget)) t.classList.remove('is-tilt');
      });
    }
  }

  /* Celebración real al añadir al carrito: confeti + punto que vuela al carrito */
  window.chCelebrate = function () {
    if (reduce || !d.body.animate) return;
    var el = d.querySelector('.ch-sticky.is-on [data-buy]') || d.querySelector('#ch-buy');
    if (!el) return;
    var r = el.getBoundingClientRect();
    var cx = r.left + r.width / 2;
    var cy = r.top + r.height / 2;
    var colors = ['#F2A9BB', '#FF7518', '#FFFFFF', '#111111'];
    for (var i = 0; i < 28; i++) {
      var p = d.createElement('span');
      p.setAttribute('aria-hidden', 'true');
      p.style.cssText = 'position:fixed;z-index:200;pointer-events:none;left:' + cx + 'px;top:' + cy +
        'px;width:' + (6 + Math.random() * 6) + 'px;height:' + (8 + Math.random() * 8) +
        'px;border-radius:2px;background:' + colors[i % colors.length] + ';box-shadow:0 0 0 1px rgba(0,0,0,.15)';
      d.body.appendChild(p);
      var a = Math.random() * Math.PI * 2;
      var dist = 70 + Math.random() * 130;
      var mx = Math.cos(a) * dist;
      var my = Math.sin(a) * dist;
      var anim = p.animate([
        { transform: 'translate(-50%,-50%) rotate(0deg)', opacity: 1 },
        { transform: 'translate(calc(-50% + ' + mx + 'px), calc(-50% + ' + (my - 40) + 'px)) rotate(' + (Math.random() * 540 - 270) + 'deg)', opacity: 1, offset: 0.7 },
        { transform: 'translate(calc(-50% + ' + mx + 'px), calc(-50% + ' + (my + 60) + 'px)) rotate(' + (Math.random() * 720 - 360) + 'deg)', opacity: 0 }
      ], { duration: 900 + Math.random() * 400, easing: 'cubic-bezier(.2,.7,.3,1)' });
      anim.onfinish = (function (n) { return function () { n.remove(); }; })(p);
    }
    var cart = d.querySelector('.ch-cart');
    if (cart) {
      var c = cart.getBoundingClientRect();
      var dot = d.createElement('span');
      dot.setAttribute('aria-hidden', 'true');
      dot.style.cssText = 'position:fixed;z-index:200;pointer-events:none;left:' + cx + 'px;top:' + cy +
        'px;width:18px;height:18px;border-radius:50%;background:#FF7518;box-shadow:0 0 0 3px #fff';
      d.body.appendChild(dot);
      var dx = (c.left + c.width / 2) - cx;
      var dy = (c.top + c.height / 2) - cy;
      var f = dot.animate([
        { transform: 'translate(-50%,-50%) scale(1)', opacity: 1 },
        { transform: 'translate(calc(-50% + ' + dx + 'px), calc(-50% + ' + dy + 'px)) scale(.3)', opacity: 0.2 }
      ], { duration: 750, easing: 'cubic-bezier(.5,0,.2,1)' });
      f.onfinish = function () { dot.remove(); };
    }
  };

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* Efectos extra: foco en el hero, botones magnéticos y onda al pulsar */
(function () {
  'use strict';
  var d = document;
  var mq = function (q) { return !!(window.matchMedia && window.matchMedia(q).matches); };
  var reduce = mq('(prefers-reduced-motion: reduce)');
  var hover = mq('(hover: hover) and (pointer: fine)');
  if (reduce) return;
  var BTN = '.ch-btn:not([disabled]):not(.ch-btn--disabled)';

  d.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest(BTN);
    if (!b) return;
    var r = b.getBoundingClientRect();
    var size = Math.max(r.width, r.height) * 2;
    var s = d.createElement('span');
    s.className = 'ch-ripple';
    s.setAttribute('aria-hidden', 'true');
    s.style.cssText = 'width:' + size + 'px;height:' + size + 'px;left:' + (e.clientX - r.left - size / 2) + 'px;top:' + (e.clientY - r.top - size / 2) + 'px';
    b.appendChild(s);
    window.setTimeout(function () { if (s.parentNode) s.parentNode.removeChild(s); }, 700);
  });

  if (!hover) return;

  d.addEventListener('pointermove', function (e) {
    var b = e.target.closest && e.target.closest(BTN);
    if (b) {
      var r = b.getBoundingClientRect();
      b.style.translate = ((e.clientX - r.left - r.width / 2) * 0.16) + 'px ' + ((e.clientY - r.top - r.height / 2) * 0.25) + 'px';
    }
    var hero = e.target.closest && e.target.closest('.ch-hero');
    if (hero) {
      var h = hero.getBoundingClientRect();
      hero.style.setProperty('--hx', ((e.clientX - h.left) / h.width * 100) + '%');
      hero.style.setProperty('--hy', ((e.clientY - h.top) / h.height * 100) + '%');
    }
  }, { passive: true });

  d.addEventListener('pointerout', function (e) {
    var b = e.target.closest && e.target.closest('.ch-btn');
    if (b && !b.contains(e.relatedTarget)) b.style.translate = '';
  });
})();
